export type DeveloperBadge =
  | { type: 'availability'; label?: string }
  | { type: 'company'; label: string };

export interface Developer {
  firstName: string;
  lastName: string;
  role: string;
  image: string;
  badge?: DeveloperBadge;
}

export const toColumns = (
  items: Developer[],
  columns: number
): Developer[][] => {
  const result: Developer[][] = Array.from({ length: columns }, () => []);
  items.forEach((dev, index) => {
    result[index % columns].push(dev);
  });
  return result;
};
